import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { ConstraintSpec } from '../constraint-spec'
import { ConstraintUtils } from '../constraint-utils'
import { ConstraintSpecDetailComponent } from '../constraint-spec-detail/constraint-spec-detail.component'

export interface IConstraintDialogOptions {
  readonly constraint: ConstraintSpec
}

@Component({
  selector: 'app-constraint-spec-detail-dialog',
  templateUrl: './constraint-spec-detail-dialog.component.html',
  styleUrls: ['./constraint-spec-detail-dialog.component.scss'],
  imports: [ConstraintSpecDetailComponent],
})
export class ConstraintSpecDetailDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly constraint: ConstraintSpec
  public readonly original: ConstraintSpec
  private dialogRef = inject<MatDialogRef<ConstraintSpecDetailDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<IConstraintDialogOptions>(MAT_DIALOG_DATA)
    this.constraint = new ConstraintSpec()
    this.original = data.constraint
    ConstraintUtils.update(this.original, this.constraint)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose($event: Event): void {
    this.close()
  }

  public onSave($event: Event): void {
    this.close(this.constraint)
  }

  public close(constraint?: ConstraintSpec): void {
    this.dialogRef.close(constraint)
  }
}
